import React from 'react';
import { getSectionContent, getDefaultContent } from '../services/contentService';
import './WhatWeDo.css';

// Import images directly (fallback)
import skillsImage from '../assets/YOCILAB/PXL_20230214_142552121.MP.jpg';
import innovationImage from '../assets/YOCILAB/PXL_20230506_143134000.MP.jpg';
import youthImpactImage from '../assets/YOCILAB/DSC_7451.jpg';

const WhatWeDo = ({ content = [] }) => {
  // Get pillars section content or use default
  const pillarsSection = getSectionContent(content, 'what-we-do') || getDefaultContent('pillars');
  const { sectionLabel, mainTitle, pillars: dynamicPillars } = pillarsSection.content;

  // Fallback pillars if no dynamic content
  const defaultPillars = [
    {
      title: "Skills & Capacity Building",
      description: "We equip young people with the practical skills, digital knowledge, and leadership tools they need to succeed in the modern workforce or launch their own ventures. Our training blends innovation, entrepreneurship, and job readiness to unlock youth potential.",
      image: skillsImage
    },
    {
      title: "Innovation & Entrepreneurship",
      description: "We provide a creative space where young innovators can design, test, and scale ideas that address real community challenges. Through mentorship, incubation, and networking, we turn bold ideas into impactful enterprises.",
      image: innovationImage
    },
    {
      title: "Youth-Led Impact & Funding",
      description: "We invest in the dreams of young changemakers by offering seed funding, coaching, and visibility for initiatives that drive measurable social, environmental, and economic change.",
      image: youthImpactImage
    }
  ];

  const pillars = dynamicPillars && dynamicPillars.length > 0 ? dynamicPillars : defaultPillars;

  return (
    <section className="what-we-do" id="what-we-do">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{sectionLabel || 'WHAT WE DO'}</span>
          <h2 className="section-title">
            {mainTitle || 'We center our work around three interconnected pillars'}
          </h2>
        </div>
        
        <div className="pillars-grid">
          {pillars.map((pillar, index) => (
            <div key={index} className="pillar-card">
              <div 
                className="pillar-image" 
                style={{ 
                  backgroundImage: pillar.image ? `url(${pillar.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                <div className="pillar-overlay">
                  <h3 className="pillar-title">{pillar.title}</h3>
                  <p className="pillar-description">{pillar.description}</p>
                  <button className="learn-more-btn">Learn more</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
